import { Effect } from 'redux-saga/effects';
import { select } from 'typed-redux-saga';

import { getUserSelector, User } from '../index';

export type LoadCurrentUserSagaType = Generator<Effect, User | null>;

export const loadCurrentUser = function* (): LoadCurrentUserSagaType {
    return yield* select(getUserSelector);
};
